<template>
  <v-container fill-height>
    <v-row>
      <v-col class="text-center">
        <v-slide-y-transition>
          <v-progress-circular
            :size="150"
            :width="6"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Loading",

  beforeCreate() {
    this.$store.dispatch("main/loadHome").then(response => {
      this.$store.commit("user/user", response.data.user);
      this.$store.commit(
        "organization/campaigns",
        response.data.loyalty_system.customer_loyalty_systems
      );
      this.$store.commit(
        "organization/prepaidSettings",
        response.data.prepaid_settings
      );
      this.$store.commit("viewstate/homeDataLoaded", true);

      this.$router.push({ name: this.$route.params["intent_route"] });
    });
  }
};
</script>

<style scoped></style>
